'use strict';
(function() {
	angular.module('onboarding.services')
		.factory('contractService', contractService);

	contractService.$inject = [
		'$http', '$log', '$stateParams'
	];

	function
	contractService($http, $log, $stateParams) {

		return {
			addContract: addContract,
			deleteContract: deleteContract,
			exportAllContractSignatures: exportAllContractSignatures,
			getContractDetail: getContractDetail,
			getContracts: getContracts,
			getContractSignatures: getContractSignatures,
			getContractVersions: getContractVersions,
			rejectSignatures: rejectSignatures,
			updateContractDescription: updateContractDescription,
			updateContractStatus: updateContractStatus,
			exportContractSignatures: exportContractSignatures
		};

		function addContract(contract) {
			contract = brokerImpersonationHelper(contract);

			return $http.post('/api/contractlookup/brokercontract', contract);
		}

		function deleteContract(contractId) {
			return $http.get('/api/contractlookup/brokercontract',
				{ params: { contractId: contractId, brokerId: $stateParams.brokerId } });
		}

		function exportContractSignatures(contractId, signatureIds) {
			var request = {
				contractId: contractId,
				signatureIds: signatureIds
			};
			request = brokerImpersonationHelper(request);

			return $http.post('/api/contractlookup/exportsignatures', request);
		}

		function exportAllContractSignatures(contractid) {
			return $http.get('/api/contractlookup/exportallsignatures',
				{ params: { contractId: contractid, brokerId: $stateParams.brokerId } });
		}

		function getContractDetail(contractId) {
			return $http.get('/api/contractlookup/brokercontractdetail',
				{ params: { contractId: contractId, brokerId: $stateParams.brokerId } });
		}

		function getContracts(filter) {
			return $http.get('/api/contractlookup/brokercontract',
				{ params: { filter: filter, brokerId: $stateParams.brokerId } });
		}

		function getContractSignatures(contractId, startRow, rowCount, sortOrder, isSortDescending, filter, filterType) {
			var request = {
				contractId: contractId,
				startRow: startRow,
				rowCount: rowCount,
				isSortDescending: isSortDescending,
				sortOrder: sortOrder,
				filter: filter,
				filterType: filterType
			};

			request = brokerImpersonationHelper(request);

			return $http.post('api/contractlookup/signedcontracts', request);
		}

		function getContractVersions(contractName) {
			return $http.get('/api/contractlookup/contractversions',
				{ params: { name: contractName, brokerId: $stateParams.brokerId } });
		}

		function rejectSignatures(signatureIds) {
			var request = {
				signatureIds: signatureIds
			};
			request = brokerImpersonationHelper(request);

			return $http.put('/api/contractlookup/rejectsignatures', request);
		}

		function updateContractDescription(contractId, name, description) {
			var request = {
				contractId: contractId,
				contractName: name,
				description: description
			};

			request = brokerImpersonationHelper(request);

			return $http.put('/api/contractlookup/brokercontractdescription', request);

		}

		function updateContractStatus(contractId, status, contractName) {
			var request = {
				contractId: contractId,
				status: status,
				name: contractName
			};

			request = brokerImpersonationHelper(request);

			return $http.put('/api/contractlookup/contractstatus', request);
		}

		function brokerImpersonationHelper(request) {
			if ($stateParams.brokerId) {
				request.brokerId = $stateParams.brokerId;
			}

			return request;
		}
	}

})();
